
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoOqYgWBddSxkiLa9MPDQZGQuv3RrPzfEtEUVajFiVvokMeta } from "/var/www/2025-04-30_17_24/pages/edo.vue?macro=true";
import { default as helpEtW_45SkDy_6QDTt6QZgfbW0vkZdDFDbGSEqaBQIJFkrMMeta } from "/var/www/2025-04-30_17_24/pages/help.vue?macro=true";
import { default as cargosX_45vUZaglVr3_45_Z7IdAxDCJi7Ke_45H8a1e0NQ6YWk39EMeta } from "/var/www/2025-04-30_17_24/pages/cargo.vue?macro=true";
import { default as china8tMIhTAjA_45iGC941NP8JFABhEeMSNwqofeLVftGqoVYMeta } from "/var/www/2025-04-30_17_24/pages/china.vue?macro=true";
import { default as indexrmvwXreA9B9Y83zuOOnHvjEOoyJRGWwwSPC8BYkoYJIMeta } from "/var/www/2025-04-30_17_24/pages/index.vue?macro=true";
import { default as _91slug_93etO2LBpTPPkX2oPIIMw431uosTAN7AMkdC2hV6ZOQ2cMeta } from "/var/www/2025-04-30_17_24/pages/[slug].vue?macro=true";
import { default as belarus67qVQFLTDy_NAub_45043VTMVQVGYtMXH8mZBCi9gyKwIMeta } from "/var/www/2025-04-30_17_24/pages/belarus.vue?macro=true";
import { default as bonusesx3ioD6VqcduK6PsAlVp9AVMImbgtQB24LVKZYXNucTsMeta } from "/var/www/2025-04-30_17_24/pages/bonuses.vue?macro=true";
import { default as apicixrXGrEZanHArvenPluNwN9GcD_0oYKVENkcBlURYgMeta } from "/var/www/2025-04-30_17_24/pages/dev/api.vue?macro=true";
import { default as cmsRYnOxAk7EfIollLtsgf_45XwhKGHjPAqIaM3PTJgcmva0Meta } from "/var/www/2025-04-30_17_24/pages/dev/cms.vue?macro=true";
import { default as konkursy3GvPs9_PZ8g3f5heZ6VFUwdhKz4ENdDkNSHlt4TaP0Meta } from "/var/www/2025-04-30_17_24/pages/konkurs.vue?macro=true";
import { default as success9sFi8bV2gsKyUn7nE3890Y90ZZUoHyccjk_457PWU_VsYMeta } from "/var/www/2025-04-30_17_24/pages/success.vue?macro=true";
import { default as tariffsU8GyMa8P9xs6DYdSDRMtjWu9pK0_45reyz47pP1nxeYUAMeta } from "/var/www/2025-04-30_17_24/pages/tariffs.vue?macro=true";
import { default as vacancyTgkk_45ZAs9M_45s_85q9jI0ygwM4Cogs3ItnHgabbKCYYcMeta } from "/var/www/2025-04-30_17_24/pages/vacancy.vue?macro=true";
import { default as contacts4ZXn3ETTVVjX1wZCsRm5P0jho7wCD7wlj6b1xNQPvuoMeta } from "/var/www/2025-04-30_17_24/pages/contacts.vue?macro=true";
import { default as giveawayWURgoqIqFugm1TIeDImn53g27hwSTxbypIxbesb3xkEMeta } from "/var/www/2025-04-30_17_24/pages/giveaway.vue?macro=true";
import { default as guide_45lkn9uyhw2C_45dLYE0SPe44GKCA_45fkCtzQczAkZ0dgrkJlMMeta } from "/var/www/2025-04-30_17_24/pages/guide-lk.vue?macro=true";
import { default as servicesl9y50mqfvamitOMGvGkcvKJLgyA1B4dHiJBtExaNu7QMeta } from "/var/www/2025-04-30_17_24/pages/services.vue?macro=true";
import { default as telegrampDLQSN81MZzmlUct_xRS_45fxBDqpTigHtkblqfD8XMbAMeta } from "/var/www/2025-04-30_17_24/pages/telegram.vue?macro=true";
import { default as documentsSV_45bi051n84Wqr9mXwBos3sySCeUEtdHx6aSLteFE1AMeta } from "/var/www/2025-04-30_17_24/pages/documents.vue?macro=true";
import { default as franchiseCQSxi3lqIKPdcDED5p0mPsI2Lg_45wMQuqvqNDZDSTKP8Meta } from "/var/www/2025-04-30_17_24/pages/franchise.vue?macro=true";
import { default as insurancejx1Lpay6DLB9CCoFITPZHHYpW1__LYoZ0h8ADJWzEJMMeta } from "/var/www/2025-04-30_17_24/pages/insurance.vue?macro=true";
import { default as kirghiziat0cN_453j_45Gz6kpfi55yrmwgf1wLiVst56ucO_zzO_45YzYMeta } from "/var/www/2025-04-30_17_24/pages/kirghizia.vue?macro=true";
import { default as mapScheme6TexSeR_45z3K_45Ii46Wz4W48SYaG_45X3tUTmwD1G8Y3rfsMeta } from "/var/www/2025-04-30_17_24/pages/mapScheme.vue?macro=true";
import { default as _91id_93USI4MNXAwtuJiNLHDnaD1nChgJtZpD3Fnu5FEAwT7swMeta } from "/var/www/2025-04-30_17_24/pages/news/[id].vue?macro=true";
import { default as return_45sdLMVcV3sdoizIWkHTSJpDHTwQbAuSuD8Yo6qsYyCJoHkMeta } from "/var/www/2025-04-30_17_24/pages/return-sd.vue?macro=true";
import { default as smsClientlzjJNiaqWGcTu57ExS7eL_45li6RjLzM0QsQ_pQHK9Rl8Meta } from "/var/www/2025-04-30_17_24/pages/smsClient.vue?macro=true";
import { default as terminalsYCfhOMSctUFEOUgT6I39cgJxqdEmhHS8BaJjUhl7rDcMeta } from "/var/www/2025-04-30_17_24/pages/terminals.vue?macro=true";
import { default as iframeiRjsacy5s350y87z93DvMK0e_0CmJhD3vU4PqwY6kVYMeta } from "/var/www/2025-04-30_17_24/pages/dev/iframe.vue?macro=true";
import { default as directionsRounDD9BBjlSIdMMytwqQmKIBH_kg1M9Dn4MfUCosYAMeta } from "/var/www/2025-04-30_17_24/pages/directions.vue?macro=true";
import { default as kazakhstanqxIU6n6YJWaPH9IB3okx_45pbWlKXs5xyUZoCngeE4BG8Meta } from "/var/www/2025-04-30_17_24/pages/kazakhstan.vue?macro=true";
import { default as indexnklWnh2goXwHCSZl7_45lGxpY99b2EPTEUeP24Ws7EG5AMeta } from "/var/www/2025-04-30_17_24/pages/news/index.vue?macro=true";
import { default as svg7kFos_45j2xaHcxNk_aWs6wxCJn2Jes6kaKoUB5zJzGP8Meta } from "/var/www/2025-04-30_17_24/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failzCMDHMYn4cL8XHqLk0oa3yrJqmevaxE0Yqqm_iXlNhoMeta } from "/var/www/2025-04-30_17_24/pages/vzpay-fail.vue?macro=true";
import { default as constructor7X1PNMK1bITvV8WtbwpnCvbIPxAaXtMtxUvkSrVd_G0Meta } from "/var/www/2025-04-30_17_24/pages/constructor.vue?macro=true";
import { default as indexT_45XyIR_AIldn5BHu1_45bAsvTDsISmzd7Qh05Tz_J7ursMeta } from "/var/www/2025-04-30_17_24/pages/gifts/index.vue?macro=true";
import { default as informationuu_Rv8nRiPrDJAMXI8LJ1icjizpZ4PFkzlLU3q9uZYMMeta } from "/var/www/2025-04-30_17_24/pages/information.vue?macro=true";
import { default as light26fQdaI5O_S4QtifYgoBA591jhpBTLkBNhp7mgHXCz0Meta } from "/var/www/2025-04-30_17_24/pages/order/light.vue?macro=true";
import { default as claim_45filing_C9KgUU1ZoDRbkUvelipMXYo0m2f4Q7ICTRBYpG68P8Meta } from "/var/www/2025-04-30_17_24/pages/claim-filing.vue?macro=true";
import { default as _91type_93GtZGoILedZG4iItnrDIK3LxbR8adTHnnCCR6MzL708IMeta } from "/var/www/2025-04-30_17_24/pages/gifts/[type].vue?macro=true";
import { default as marketplacesC75Y3foGDNsWDL7_454sUULn3QCUWt4MDrM8eBdcvtJlkMeta } from "/var/www/2025-04-30_17_24/pages/marketplaces.vue?macro=true";
import { default as networkshops6m8p3_45HzHmCiGZvcg_453ir3_45F4QvoEgPSviXDFzAaOJcMeta } from "/var/www/2025-04-30_17_24/pages/networkshops.vue?macro=true";
import { default as online_45storeiLW09UlSHIXPofIw527FkNK9LwMntH8cvYHFsjTDZmwMeta } from "/var/www/2025-04-30_17_24/pages/online-store.vue?macro=true";
import { default as managehroYZJH1iACFuI3mmDpFPTASGmK59nRVscAHh_45J7rIQMeta } from "/var/www/2025-04-30_17_24/pages/order/manage.vue?macro=true";
import { default as registrationKUKN5rbinFw0jUL1E2EUIC7DfgT9Dbm_o9jq7fcOuJgMeta } from "/var/www/2025-04-30_17_24/pages/registration.vue?macro=true";
import { default as run_45scheduledR41ad3EY16oZhq7_6v4NUt6BjngpeXmFJ0VZoa_459aoMeta } from "/var/www/2025-04-30_17_24/pages/run-schedule.vue?macro=true";
import { default as safe_45custodyrvGyYlk_286MIEXFhx3kZWD3x4Dx_45aI27Tw9yydlpeAMeta } from "/var/www/2025-04-30_17_24/pages/safe-custody.vue?macro=true";
import { default as imageAbd9m1AwtGVdwCj7ii0zfyQi2CRBxdl87tKbhl1Wi54Meta } from "/var/www/2025-04-30_17_24/pages/ui-kit/image.vue?macro=true";
import { default as indexzRTxjomb1xC1biUVJz_5J5At5W5oUkvdGQxNyYjRKDEMeta } from "/var/www/2025-04-30_17_24/pages/ui-kit/index.vue?macro=true";
import { default as bagoYvcRUrlKnSMJvSQB5O9CCu_Irg5Ckc9MnfMheuJzRsMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/bag.vue?macro=true";
import { default as boxk87aPYGw0oKSp759bAUHVcSmCAhSLzmGmKPoU2Ts0IUMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingNUJQB9RYjcO0OcF8RZivRQBAlPolL_Goqx_45VDpD3NCsMeta } from "/var/www/2025-04-30_17_24/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayXaPDL5RDDA0MODz2IztYG1bNW_7MMmYWRd4Ug7PYKNQMeta } from "/var/www/2025-04-30_17_24/pages/happybirthday.vue?macro=true";
import { default as managew12D6p4LDXdsgILSN0zWWNvlxJMHl4YyXIEcyutgh2EMeta } from "/var/www/2025-04-30_17_24/pages/iframe/manage.vue?macro=true";
import { default as authjJR8lBw4PwXj7Xfeb_458L5UQg_lE19doHX2Pjq9XmIB8Meta } from "/var/www/2025-04-30_17_24/pages/personal/auth.vue?macro=true";
import { default as publicmlhNwHQ_450r9rGLEJZhkJMPVYKotOld24bWQxyWJsNioMeta } from "/var/www/2025-04-30_17_24/pages/ui-kit/public.vue?macro=true";
import { default as already_45answerdqji07KFddai_45PrOOjHjNWYC2reFwKNA0KxNP7IjzzsMeta } from "/var/www/2025-04-30_17_24/pages/already-answer.vue?macro=true";
import { default as tariffsVdcsTWqDab_45Es7FqSV1gYQTtRp5U87Wd_45VWyH5eEGeUMeta } from "/var/www/2025-04-30_17_24/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93Db5ONyOkbb1SP5KV77J1N1TAOr3DANKw563_45SHAUuIgMeta } from "/var/www/2025-04-30_17_24/pages/order/pay/[id].vue?macro=true";
import { default as indexJcBzEMTtcwqU6yDdtO5WBqTW5Jl0VAKd8_m3uYCOFakMeta } from "/var/www/2025-04-30_17_24/pages/personal/index.vue?macro=true";
import { default as privacy_45policy_45HfeUR7bgOhy1Qb9XxFuihWx4h_FEZ9W2xJkU1wOL68Meta } from "/var/www/2025-04-30_17_24/pages/privacy-policy.vue?macro=true";
import { default as _91hash_93m828e43JMlTPrAOuALEMqP5p3dywSd6aVC1Cq44gCdoMeta } from "/var/www/2025-04-30_17_24/pages/welcome/[hash].vue?macro=true";
import { default as index3_V9WnCmQXliMaQH_45gnA7MYNheOiRri99CeSM_45Mj0qMMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiagS69HHHE_Bjz_dHSMnU6Xlc75ituVTfar_45vSKPaFvIcMeta } from "/var/www/2025-04-30_17_24/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodscCsI68j5zRs5AYk9kgcHYYgWHJ5f2wnb5g7HuGNbCIMMeta } from "/var/www/2025-04-30_17_24/pages/payment-methods.vue?macro=true";
import { default as qr_45infoQrEiyNnBCeioSoyecc_45fkZf8vuc8UD6qx5EM8l2XXJEMeta } from "/var/www/2025-04-30_17_24/pages/payment/qr-info.vue?macro=true";
import { default as success_45nOC50cbWSfdV3nKhlXR0cWWY7S9yf6QfZlALDxp2eMMeta } from "/var/www/2025-04-30_17_24/pages/payment/success.vue?macro=true";
import { default as importE6A1RlOEkq5R1dpsS199a6lOHLvOUsFoMUmTFLxBFmAMeta } from "/var/www/2025-04-30_17_24/pages/personal/import.vue?macro=true";
import { default as logout0nGFbkmtewUNG1_4553h1XxRlBZfvgpEyxs0_45RyQMZ8HkMeta } from "/var/www/2025-04-30_17_24/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryXvhX2nO0UhdZHHCkRBq2hGS84NzdkgWhXdsou_WiFfMMeta } from "/var/www/2025-04-30_17_24/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45delivery_45GMbHLMEbN8k6pGFDmapsLgjW7y1w24IA8wB11eLteYMeta } from "/var/www/2025-04-30_17_24/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear202452tyvz43fuKflZKsl8st5h228GSRBgmEnCeIJcSNLvMMeta } from "/var/www/2025-04-30_17_24/pages/happynewyear2024.vue?macro=true";
import { default as ozondzOCE_45cMhHX5hq_QyXYIhnQ8MChGRhc_jeqU0SLYqx8Meta } from "/var/www/2025-04-30_17_24/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45faila30Itn4qPa9_454FMXA7ZOIYUr2BJavFBojEQtl5q_45wO4Meta } from "/var/www/2025-04-30_17_24/pages/payment/pay-fail.vue?macro=true";
import { default as accountNTP7ZfZNka0iLtnjUrDlJjgVX6z_x9n_dyjqpao42loMeta } from "/var/www/2025-04-30_17_24/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsa1xac03gI6i_2OqhVnAUTNasLhRqwH2GMnws4T7TkjcMeta } from "/var/www/2025-04-30_17_24/pages/prohibited-goods.vue?macro=true";
import { default as directionEJAXpufqL_sIUJKv5n_45Tilywb8KJCRrwd38rINT4YXsMeta } from "/var/www/2025-04-30_17_24/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupaTmHHIjbdTroz5Oy5ZysJYJXVpeJQSxFsIPqnDdMYEAMeta } from "/var/www/2025-04-30_17_24/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoS_45lWryLhF8WRAI4Z3V0NuVaxb0rDgwQ4IezDimqj8ykMeta } from "/var/www/2025-04-30_17_24/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorAToOrbApifw96l9l2ZYVA65RD0NG2dr07Gi3Z_45vkWREMeta } from "/var/www/2025-04-30_17_24/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesTfGhCEZT4vT_45OgYFHynEsvbCHbyjtwhvB9RJJz2FqzQMeta } from "/var/www/2025-04-30_17_24/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93_O6v6jOZtlBr1aXyJF7NFHtwgrP8beRvYHnHKL8s1k0Meta } from "/var/www/2025-04-30_17_24/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45infoVKScEfubx0IPxMSE6x1yzGZBSH16dfBxXbRBtMQq4G0Meta } from "/var/www/2025-04-30_17_24/pages/payment/card-info.vue?macro=true";
import { default as discountswhlZHCXRN_45chyB88uwo7BiC68UDKuGY1gWIvqdKI30Meta } from "/var/www/2025-04-30_17_24/pages/personal/discount.vue?macro=true";
import { default as hard_45boxcxZyW8dOLetECtFgNJ9uQTiG2KiDvBy4giltGgtVbO0Meta } from "/var/www/2025-04-30_17_24/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptMUqErtSCcVtIKQAicYNo_45XbhKj6lH3lX7CIlQFmH2Z4Meta } from "/var/www/2025-04-30_17_24/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917Nc4FNG_45zdLNrIhkUlD_452zWypMzCKwm7hIGJVLw8NZREMeta } from "/var/www/2025-04-30_17_24/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationRM6FtBzYPsbl4UzcaDMRdSZagrYeceSF8fYb_45QXa4IAMeta } from "/var/www/2025-04-30_17_24/pages/mobile-application.vue?macro=true";
import { default as index5uBRfA781_ExfKt_Yo_45VbS8kqHKJFCZh6RLKibcoXqsMeta } from "/var/www/2025-04-30_17_24/pages/order/create/index.vue?macro=true";
import { default as boatKhtQZbc02huwa2FBc_rI24xBK7FXpNzBwNEfCzRDjWAMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/boat.vue?macro=true";
import { default as sofap6Vud4FEkSIrO8bEaMKiEU6dF8HSGQlZvmsw78RDPrgMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardZVmEKmX6GbJfh9NXIDc8iwb7jVJSV_TBVk9YZxU8TxwMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesPUqAvYtOibS2Z67d6Z3boigYeiO7VDZ_45R3aX3s79cnEMeta } from "/var/www/2025-04-30_17_24/pages/personal/promocodes.vue?macro=true";
import { default as bench2UEYWJthN_45HKxNwnzyY96ReFThJeYQBVqspoVlzdWpIMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/bench.vue?macro=true";
import { default as books0W2aYvnyVRhD_6GMVF4TuAUDhU6Xrau37_2XTSZSm1cMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/books.vue?macro=true";
import { default as cable_45QN6Cp6aiRe_Z3ehKhuWTWjQ1PmdUHc7_9W0kc_TwJkMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/cable.vue?macro=true";
import { default as chairjYMvt_45xrDBWV22Gt59iRpoRRFUDvdLWi0XMXRBHGsbwMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/chair.vue?macro=true";
import { default as goodsVH8GPVmi9dbswD4MW3t6azPRCvJj8x1FvJHI70ZvPOQMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/goods.vue?macro=true";
import { default as indexmR9kABbcJVEjCDQ0PZzNsWoFjQg9EBGImyKL6tDkA3oMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/index.vue?macro=true";
import { default as metalDmtERPAlXxMeVtGO4GIQOL_45lzEPQnt2OBkok9A5Aaa4Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoFfUN5hFxqUNEj_8QhCJ2RDi_45_45W6qI4GtkIXBFVVbyh4Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesybHeGceIhD1MTaJYBte6qT_45zEF70KiRzdvBLIlGBL0oMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/pipes.vue?macro=true";
import { default as tools2PVExIemwmq4sXNg6u5wK17Abwhkh4pEYJKDZvOHfjQMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxP969PbLu2YjkDaAS9cUV3z_y7y28KvYJ0qQ3flNqrF4Meta } from "/var/www/2025-04-30_17_24/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93I9omDlu_45os94ye8ZCyhUhs2_8BHRLEQ7IOCTJePNcfQMeta } from "/var/www/2025-04-30_17_24/pages/personal/bonus/[tab].vue?macro=true";
import { default as printG9D55g6umdPPmAK1nanmxsdL2KwN5JqqK_JYMdG_45kpIMeta } from "/var/www/2025-04-30_17_24/pages/personal/order/print.vue?macro=true";
import { default as dishesUSp3jiHXvKsZrZduqVmwEA5Ac_45A33cKm89zKJ_458LYCsMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginef88Lxn5dqxca1baAbtiHI4tsZ_45613t48VwBtLeE98KUMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/engine.vue?macro=true";
import { default as lumber_58KoX6c9I0eSUb_LOni48o__bwP7yhgJUl_45bzC19V8Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsvmwLHpgk41aue9uG7mybnstSmacIYl_3Qnf1vbqia48Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmTTIYctPPGaJ6IDC0EGssyABhJTRNKNnT6oxLnZaO2OMMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletising4V_45uRDOWFEt4q7p2RDabiNlDPDOeqdtnHBOgFg25q2QMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalW_k6evMTF1wn_45luK_45EgZQcPis0vPNUP3dU_45M1O67SPMMeta } from "/var/www/2025-04-30_17_24/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93lseWP0mBylzI26o3FnNK0wfDEpxcHXXP9ZmGYRO2mvoMeta } from "/var/www/2025-04-30_17_24/pages/personal/order/[guid].vue?macro=true";
import { default as create09d_45j265miQGLU_45eGBP51WyDcqJk_45QM8ob0CLRZa7yYMeta } from "/var/www/2025-04-30_17_24/pages/personal/order/create.vue?macro=true";
import { default as barrelslCJoc5XV4gWjHIUqqUW7xtlSDGnvXj8p6F1vtiXi2psMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesM4ZqB5RoK9yMfS8h5Cx837gl1FlsKnGVc7AntPWGT0YMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragilecCk8aCyzzGp40p3wydK5AGnXy9H6VNv07LKp5qB3G1MMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerJNgD3CP18pGZqM4DbZQHjKG5YAegs5MEm9EP7omw1lQMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45package0nKRTPNK7cnwmZVSO6U69jGXgcoZF44oE_45L584oTCJ0Meta } from "/var/www/2025-04-30_17_24/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successcM8pHDR57bzOFlTGk4uZpJJItS80UCyShanYbQp2NxUMeta } from "/var/www/2025-04-30_17_24/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packageQEqmQFn9u4u8jJ7xrfRPxwywBUXR8WW8f3iqHbOH7MkMeta } from "/var/www/2025-04-30_17_24/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesm7jKwwjPfBERU6y89oBZnQBkB00OyxCKt90afL7Gx_8Meta } from "/var/www/2025-04-30_17_24/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_932_Qp5hahltQN3cnHY5ItwmcO18jgDKrks3695aFveFgMeta } from "/var/www/2025-04-30_17_24/pages/order/administer/[guid].vue?macro=true";
import { default as furnitureV7f_4504CGtj5bFvq5RUOYt8nMiyJ1yFVzcAFiB4c0F0cMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedsmZtiHwIS7jJZCYs7zXmM_QWso3Qhp248FQUHWorqjYMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeJkHJuvjtzsmOK1SO8fjgI_UFfJzqHegs52t0zABz4CgMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93jryyBxWuqut_45BRRXcjGLAxupDsZIKkPGVDTqezf26qkMeta } from "/var/www/2025-04-30_17_24/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93suoSorE7_45cTDeH7JjYLzZChoGFQBAGYq9ldUX_TxR7oMeta } from "/var/www/2025-04-30_17_24/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partsSpyYHoBr8sCOL188c2z048qyHcCquv3g8gmxx7iv9KgMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersmk0P9yRoeFMbXZ3GIxRdChOfBDygdX87n6nbhGpiV4oMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargoWfv8eC_SIJ9Y5RhNNgoKGYr8XQF135E2ZKM_aySiLdAMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilesTtG_45ZOZoa5O05iRXxPkhZbc7aHLsfXVLKnIdq6Og_45kMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexdWhNYtbHSUf4ig5mXzH5il8AHBJ_bozGEH0EBIwbs64Meta } from "/var/www/2025-04-30_17_24/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketsJQ7peboarRsDLajmZPvYfhi_DY0NsrgpQ6vVxZAancMeta } from "/var/www/2025-04-30_17_24/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesR4os_6agOjpDhlaH4K_45vl6X4serDVwmzE1T13rBWgw8Meta } from "/var/www/2025-04-30_17_24/pages/personal/orders/templates.vue?macro=true";
import { default as indexfKh23TVIsTG_45AIp_452M_45aG6Eu_yvo0725wincDYaD6LsMeta } from "/var/www/2025-04-30_17_24/pages/personal/contractors/index.vue?macro=true";
import { default as refrigeratorFI_VedWxFyyS329X_ync0BaIybwatRKu4voLIKHkf2YMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93hp_EXvGuhuLPX8cYRsdas5DJhOuiyRQfv8E6S3VifykMeta } from "/var/www/2025-04-30_17_24/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexGFwOzmLLvwXmoGIiI_2Lo5QeUU1kqsoI_45_Yb7SDtqksMeta } from "/var/www/2025-04-30_17_24/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93Xg_TyvxdEA87QVvOdGW9R5unVGiMl_NaH7xy88q_45DfkMeta } from "/var/www/2025-04-30_17_24/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsnBlpO10ON2f2vkvvchWe736AMzxr1MRDQE0f0rVqGy0Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexcflM_qQV37XlCf0KTL7DdWRw_45rWL2XQXZBJsEicx1RAMeta } from "/var/www/2025-04-30_17_24/pages/personal/group-printing/index.vue?macro=true";
import { default as index0_ThLO1HZD2Yv_45tvskNhdsu2_45eaC0kjvoF8KPBctWHIMeta } from "/var/www/2025-04-30_17_24/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesyV2dVCOn9Hw9rtsg6Gi_45jbM98njYvfelwGVUvT3tCWEMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93kL7dFjAgC8AJhWwRWJhuJwBsjR2F_QyhsCi1BCdOsIoMeta } from "/var/www/2025-04-30_17_24/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93V5AZeTDTdRVzj4CZheM65ABOJCi0f4UE54lMWsi_45AucMeta } from "/var/www/2025-04-30_17_24/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93xQPgyw5Y8AtSetZaqa_N8y9XF2gaOhxjmRtkbU_BVhEMeta } from "/var/www/2025-04-30_17_24/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipment6lKwca2SR_Qm4rLsfhk5x0cd7Zl1pEgTILgTVL94Tz8Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materials6ERpmYl7cDjesDIt5WMH_GFatEF214GPdxCD9eeJBLoMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentspUwoUFeG2V7m3JPcCZzQwx4iSqOYTFFTv2Scr_45gt2qoMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentaORNBkObXZCgUG8yi0qviGbrEaT6_VZVXiU6H3WT4LgMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationkORlkTE8IE6ftJ8YVo3Endxq2pY13QtXbvFm44J8q98Meta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_931VaQ6uW9Jap4htevl1VNAO2WYk1U5_45QqCOZmFLGYl9YMeta } from "/var/www/2025-04-30_17_24/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationB2VhJlNf4P55VgO6SdTjc_TOOr2yNoUut7QAEtsd5LYMeta } from "/var/www/2025-04-30_17_24/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-04-30_17_24/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-04-30_17_24/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-04-30_17_24/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-04-30_17_24/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-04-30_17_24/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93etO2LBpTPPkX2oPIIMw431uosTAN7AMkdC2hV6ZOQ2cMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-04-30_17_24/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-04-30_17_24/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-04-30_17_24/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-04-30_17_24/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursy3GvPs9_PZ8g3f5heZ6VFUwdhKz4ENdDkNSHlt4TaP0Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-04-30_17_24/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-04-30_17_24/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-04-30_17_24/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contacts4ZXn3ETTVVjX1wZCsRm5P0jho7wCD7wlj6b1xNQPvuoMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-04-30_17_24/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-04-30_17_24/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-04-30_17_24/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-04-30_17_24/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-04-30_17_24/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-04-30_17_24/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-04-30_17_24/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-04-30_17_24/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapScheme6TexSeR_45z3K_45Ii46Wz4W48SYaG_45X3tUTmwD1G8Y3rfsMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93USI4MNXAwtuJiNLHDnaD1nChgJtZpD3Fnu5FEAwT7swMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-04-30_17_24/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-04-30_17_24/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-04-30_17_24/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-04-30_17_24/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-04-30_17_24/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-04-30_17_24/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexnklWnh2goXwHCSZl7_45lGxpY99b2EPTEUeP24Ws7EG5AMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-04-30_17_24/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-04-30_17_24/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructor7X1PNMK1bITvV8WtbwpnCvbIPxAaXtMtxUvkSrVd_G0Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexT_45XyIR_AIldn5BHu1_45bAsvTDsISmzd7Qh05Tz_J7ursMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-04-30_17_24/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-04-30_17_24/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93GtZGoILedZG4iItnrDIK3LxbR8adTHnnCCR6MzL708IMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-04-30_17_24/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-04-30_17_24/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-04-30_17_24/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-04-30_17_24/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-04-30_17_24/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-04-30_17_24/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-04-30_17_24/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-04-30_17_24/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-04-30_17_24/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayXaPDL5RDDA0MODz2IztYG1bNW_7MMmYWRd4Ug7PYKNQMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: managew12D6p4LDXdsgILSN0zWWNvlxJMHl4YyXIEcyutgh2EMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-04-30_17_24/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-04-30_17_24/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsVdcsTWqDab_45Es7FqSV1gYQTtRp5U87Wd_45VWyH5eEGeUMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexJcBzEMTtcwqU6yDdtO5WBqTW5Jl0VAKd8_m3uYCOFakMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-04-30_17_24/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-04-30_17_24/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-04-30_17_24/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-04-30_17_24/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-04-30_17_24/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-04-30_17_24/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importE6A1RlOEkq5R1dpsS199a6lOHLvOUsFoMUmTFLxBFmAMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logout0nGFbkmtewUNG1_4553h1XxRlBZfvgpEyxs0_45RyQMZ8HkMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-04-30_17_24/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-04-30_17_24/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear202452tyvz43fuKflZKsl8st5h228GSRBgmEnCeIJcSNLvMMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozondzOCE_45cMhHX5hq_QyXYIhnQ8MChGRhc_jeqU0SLYqx8Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-04-30_17_24/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountNTP7ZfZNka0iLtnjUrDlJjgVX6z_x9n_dyjqpao42loMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-04-30_17_24/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-04-30_17_24/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-04-30_17_24/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-04-30_17_24/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorAToOrbApifw96l9l2ZYVA65RD0NG2dr07Gi3Z_45vkWREMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-04-30_17_24/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-04-30_17_24/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountswhlZHCXRN_45chyB88uwo7BiC68UDKuGY1gWIvqdKI30Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-04-30_17_24/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917Nc4FNG_45zdLNrIhkUlD_452zWypMzCKwm7hIGJVLw8NZREMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-04-30_17_24/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: index5uBRfA781_ExfKt_Yo_45VbS8kqHKJFCZh6RLKibcoXqsMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesPUqAvYtOibS2Z67d6Z3boigYeiO7VDZ_45R3aX3s79cnEMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93I9omDlu_45os94ye8ZCyhUhs2_8BHRLEQ7IOCTJePNcfQMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printG9D55g6umdPPmAK1nanmxsdL2KwN5JqqK_JYMdG_45kpIMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-04-30_17_24/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93lseWP0mBylzI26o3FnNK0wfDEpxcHXXP9ZmGYRO2mvoMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: create09d_45j265miQGLU_45eGBP51WyDcqJk_45QM8ob0CLRZa7yYMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-04-30_17_24/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-04-30_17_24/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesm7jKwwjPfBERU6y89oBZnQBkB00OyxCKt90afL7Gx_8Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93suoSorE7_45cTDeH7JjYLzZChoGFQBAGYq9ldUX_TxR7oMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexdWhNYtbHSUf4ig5mXzH5il8AHBJ_bozGEH0EBIwbs64Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketsJQ7peboarRsDLajmZPvYfhi_DY0NsrgpQ6vVxZAancMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesR4os_6agOjpDhlaH4K_45vl6X4serDVwmzE1T13rBWgw8Meta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexfKh23TVIsTG_45AIp_452M_45aG6Eu_yvo0725wincDYaD6LsMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93hp_EXvGuhuLPX8cYRsdas5DJhOuiyRQfv8E6S3VifykMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexGFwOzmLLvwXmoGIiI_2Lo5QeUU1kqsoI_45_Yb7SDtqksMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93Xg_TyvxdEA87QVvOdGW9R5unVGiMl_NaH7xy88q_45DfkMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexcflM_qQV37XlCf0KTL7DdWRw_45rWL2XQXZBJsEicx1RAMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: index0_ThLO1HZD2Yv_45tvskNhdsu2_45eaC0kjvoF8KPBctWHIMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93kL7dFjAgC8AJhWwRWJhuJwBsjR2F_QyhsCi1BCdOsIoMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93V5AZeTDTdRVzj4CZheM65ABOJCi0f4UE54lMWsi_45AucMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93xQPgyw5Y8AtSetZaqa_N8y9XF2gaOhxjmRtkbU_BVhEMeta || {},
    component: () => import("/var/www/2025-04-30_17_24/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-04-30_17_24/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-04-30_17_24/pages/shippingtypes/personalitemstransportation.vue")
  }
]